import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=7cb042d0&scoped=true&"
import script from "./Safety.vue?vue&type=script&lang=js&"
export * from "./Safety.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Safety-pc.css?vue&type=style&index=0&id=7cb042d0&scoped=true&lang=css&"
import style1 from "../assets/css/Safety-phone.css?vue&type=style&index=1&id=7cb042d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb042d0",
  null
  
)

export default component.exports